import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class ShiftMembers extends Vue
{
    @Prop() username!: string;
    @Prop() firstName!: string;
    @Prop() lastName!: string;
    @Prop() skill!: string;
}
